export default "__VITE_ASSET__BTs9WvYF__"